import { type Position } from '../../hooks/highlight-manager';
import { useHighlightManager } from '../../hooks/use-highlight-manager';

type ParsedQueryData<TData> = {
  data: TData;
  position: Position[];
} | undefined;

export const useParseHighlight = <TData>(
  queryData: ParsedQueryData<TData> | undefined,
) => {
  const positionData = queryData?.position[0];
  useHighlightManager(positionData);

  return { data: queryData?.data };
};
